// Shopify receives submissions and renders success/errors; never fake a success in JS.
document.addEventListener('click', event => {
  const link = event.target.closest('a[href="#rh-password-access"],a[href="#rh-launch-privacy"]');
  if (!link) return;
  const details = document.querySelector(link.getAttribute('href'));
  if (details) details.open = true;
});
const signup = document.getElementById('RoseheadLaunchSignup');
if (signup) {
  const message = signup.querySelector('.rh-launch-validation');
  signup.addEventListener('invalid', event => {
    if (message) { message.hidden = false; message.textContent = 'Please enter a valid email address and agree to email updates.'; }
    event.target.setAttribute('aria-invalid', 'true');
  }, true);
  signup.addEventListener('input', event => { event.target.removeAttribute('aria-invalid'); if(message) message.hidden = true; });
}
document.querySelector('.rh-form-success, .rh-form-errors')?.focus();
